import { css } from 'styled-components'

// Shared by the app shell (view wrappers) and the word-cloud chrome (Hud):
// absolutely positioned, click-through by default, HUD typeface.
export const base = css`
  font-family: 'Teko', sans-serif;
  position: absolute;
  font-variant-numeric: slashed-zero tabular-nums;
  line-height: 1.1em;
  pointer-events: none;
  color: white;
`
